export const TableAppTags = {
    newApp: { key: 'newApp', label: 'New App' },
    existingApp: { key: 'existingApp', label: 'Existing App' },
};

export const MLAppAction = {
    APPROVE: 'Approve',
    REJECT: 'Reject'
}

export const MLApiRequestTypes = {
    ML_SCORE_TABLE_DATA: 'mlScoreTableData',
    ML_SCORE_ACTION: 'mlScoreAction',
    GET_ML_SCORE_APP_DATA: 'getMlScoreAppData',
};

export const MLScoreLabels = {
    appInfo: 'App Information',
    appName: 'App Name',
    appCategory: 'App Category',
    appUrl: 'App URL',
    aiExecutionDate: 'AI Execution Date',
    existingCci: 'Existing CCI',
    appTags: 'App Tags',
    aiGeneratedCci: 'AI-Generated CCI',
    completionStatus: 'Completion Status',
    lastReviewedDate: 'Last Reviewed Date',
};

export const MLScoreTexts = {
    showDiffOnly: 'Show Difference Only',
    mlScorePageTitle: 'Fully Automated Research Workflow',
};

export const MLScoreTabs = {
    pendingRequests: 'Pending Requests',
    history: 'History',
};
